import { Button, Modal } from "antd";

const performList = [];

const addPerform = ({ name }) => {
  const item = {
    name,
    time: performance.now(),
  };
  performList.push(item);
};

const getPerformList = () => {
  return performList;
};

const logPerform = () => {
  const infoList = getPerformTimeInfoList();
  infoList.forEach(info => {
    console.log(info);
  });
  // showLogModal();
};

const getPerformInfo = (idx, item, deltaPrev, deltaBase) => {
  return `[${idx}] ${item.name} time=${item.time.toFixed(3)}ms +prev=${deltaPrev.toFixed(3)}ms +base=${deltaBase.toFixed(3)}ms`
}

const getPerformTimeInfoList = () => {
  const list = getPerformList();

  let prevTime = null;
  const baseTime = list[0]?.time ?? null;

  const result = [];
  result.push(`=============== Performance Log ===============`);
  list.forEach((item, idx) => {
    const deltaPrev = prevTime == null ? 0 : item.time - prevTime;
    const deltaBase = baseTime == null ? 0 : item.time - baseTime;

    result.push(getPerformInfo(idx, item, deltaPrev, deltaBase));

    prevTime = item.time;
  });
  result.push(`=============== Performance Log End ===============`);
  return result;
};

let perfModal = null;

const showLogModal = () => {
  const infoList = getPerformTimeInfoList();

  if (perfModal) perfModal.destroy();

  perfModal = Modal.info({
    title: "Performance Log",
    width: 900,
    mask: false,
    okText: <Button style={{ marginRight: 10, marginLeft: 10 }} type="primary" onClick={() => {
      perfModal = null;
    }}>Close</Button>,
    content: (
      <pre
        style={{
          margin: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          maxHeight: "60vh",
          overflow: "auto",
          fontSize: 12,
          lineHeight: 1.4,
        }}
      >
        {infoList.join("\n")}
      </pre>
    ),
    onOk: () => {
      perfModal = null;
    },
    onCancel: () => {
      perfModal = null;
    },
  });
};

export { addPerform, logPerform, getPerformTimeInfoList, showLogModal };
